module.exports = __webpack_public_path__ + "static/img/freightEntrance.ef58b626.png";